import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Clipboard from 'v-clipboard'
import moment from 'moment'
import firebase from 'firebase';
var firebaseConfig = {
  apiKey: "AIzaSyC9a6hF9y0qU1ERm7nyn8sb-LYY_sImpEQ",
  authDomain: "doggydexx.firebaseapp.com",
  databaseURL: "https://doggydexx-default-rtdb.firebaseio.com",
  projectId: "doggydexx",
  storageBucket: "doggydexx.appspot.com",
  messagingSenderId: "798106776622",
  appId: "1:798106776622:web:d9b76e502c386c74791bbf",
  measurementId: "G-FNM64GW34T"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();
require('dotenv').config()
require('./assets/style.css')
Vue.use(Clipboard)
Vue.config.productionTip = false
Vue.prototype.moment = moment
new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
